// extracted by mini-css-extract-plugin
export default {"titleQuestion":"RegisterAuditorFormStepNine_titleQuestion__cHeLU","note":"RegisterAuditorFormStepNine_note__YPcTX"};